<template>
    <PunchSystem></PunchSystem>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const PunchSystem = defineAsyncComponent(() =>
    import("../../components/DPAM_PunchSystem/PunchSystem/PunchSystem.vue")
);

export default {
    name: "DPAM_Punch_System", //The name you are in should not equal the name of the component you are importing.
    components: { PunchSystem, AuthLayout },
};
</script>
